import React from 'react';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import BulletinSearchResults from './BulletinSearchResults';

function AlertsSearch() {
  return (
    <SearchMenu>
      <FilterConsumer>
        {({ agencies }) => <BulletinSearchResults filter={agencies} />}
      </FilterConsumer>
    </SearchMenu>
  );
}

export default AlertsSearch;
